import React from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

/**
 * Reusable DOB confirmation dialog for when patient appears < 1 year old.
 */
export default function DobConfirmDialog({ open, dob, onFix, onConfirm }) {
  const { t } = useTranslation('common');

  return (
    <Dialog
      open={open}
      onClose={onFix}
      aria-labelledby="dob-confirm-dialog-title"
      aria-describedby="dob-confirm-dialog-description"
    >
      <DialogTitle id="dob-confirm-dialog-title">
        {t('dialogs.dobConfirm.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="dob-confirm-dialog-description">
          {t('dialogs.dobConfirm.message', { dob })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onFix}>
          {t('dialogs.dobConfirm.goBack')}
        </Button>
        <Button onClick={onConfirm} variant="contained" color="warning">
          {t('dialogs.dobConfirm.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
